import AtomsBreakline from "../atoms/AtomsBreakline"
import AtomsButton from "../atoms/AtomsButton"
import AtomsText from "../atoms/AtomsText"

const OrganismsFooter = (props) => {
    const sendEmail = () => {
        const email = 'flazen.edu@gmail.com'
        const subject = 'FlazenApps Visitor'
        const body = `Hello Leo, It's Me ...,`

        const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
        window.location.href = mailtoLink
    }
    const visitURL = (url) => {
        window.open(url, '_blank')
    }

    return (
        <footer>
            <AtomsBreakline length={1}/>
            <AtomsText type='main-title' text="Let's Collaborate With Me"/>
            <AtomsText type='main-title' text="Or Wanna Create Something New?"/>
            <AtomsBreakline length={1}/>
            <hr></hr>
            <AtomsBreakline length={1}/>
            <AtomsText type='content' text="Feel free to contact me, if you wanna discuss about Software Development especially in Web or Mobile Development"/>
            <AtomsBreakline length={2}/>
            <AtomsButton class='btn-danger btn-full-mobile' text='Email Me' action={sendEmail}/>
            <AtomsButton class='btn-warning btn-full-mobile' text='My Personal Website' action={(e) => visitURL('https://leonardhors.site/v2')}/>
            <AtomsButton class='btn-warning btn-full-mobile' text='LinkedIn' action={(e) => visitURL('https://www.linkedin.com/in/leonardho-rante-sitanggang/')}/>
            <AtomsButton class='btn-success btn-full-mobile' text='Visit My Github' action={(e) => visitURL('https://github.com/FlazeFy')}/>
            <AtomsBreakline length={3}/>
            <span className="mb-3 mb-md-0">© 2025 FlazenApps</span>
        </footer>
    )
}
  
export default OrganismsFooter
